const Favorites = {
	init() {
		$('#filterItems').on('click', '.js-saveToFavorites', function () {
			$(this).parent().remove();
		});
	},
};

export default Favorites;
